"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const ChatAvatar_1 = require("./ChatAvatar");
const constants_1 = require("../../constants");
const elements_1 = require("../../elements");
// BEMLO-2668: Safari behaves weirdly for ::selection on flex items.
// This particular color seems to work across different browsers.
// Picking a darker color, like #0d2d5a can help. So does wrapping the
// text in a span.
const MessageText = styled_1.default.span(({ isMe }) => ({
    '&::selection': isMe
        ? {
            backgroundColor: '#5a89da',
        }
        : undefined,
}));
const ChatMessage = ({ id, date, isMe, sender, text, flagged, onToggleFlag, }) => {
    return ((0, jsx_runtime_1.jsxs)(elements_1.Div, { styles: {
            alignSelf: isMe ? 'flex-end' : undefined,
            display: 'grid',
            gap: '4px 12px',
            gridTemplateColumns: isMe ? '1fr 0fr' : '0fr 1fr',
            gridTemplateRows: '1fr auto',
            maxWidth: 380,
            whiteSpace: 'pre-line',
            overflowWrap: 'anywhere',
        }, children: [(0, jsx_runtime_1.jsx)(ChatAvatar_1.ChatAvatar, { image: sender.avatarUrl, name: sender.name, styles: { alignSelf: 'flex-end', order: isMe ? 1 : 0 } }), (0, jsx_runtime_1.jsx)(elements_1.Div, { styles: {
                    position: 'relative',
                    backgroundColor: isMe
                        ? flagged
                            ? constants_1.Color.MEDIUM_RED
                            : constants_1.Color.BLUE
                        : flagged
                            ? constants_1.Color.LIGHTEST_RED
                            : constants_1.Color.LIGHTEST_BLUE,
                    borderRadius: constants_1.theme.border.radius.normal,
                    color: isMe ? constants_1.Color.WHITE : undefined,
                    justifySelf: isMe ? 'flex-end' : 'flex-start',
                    px: 2.5,
                    py: 2,
                    ...(isMe
                        ? {
                            borderBottomRightRadius: 0,
                            order: 0,
                        }
                        : { borderBottomLeftRadius: 0 }),
                }, children: (0, jsx_runtime_1.jsx)(MessageText, { isMe: isMe, children: text }) }), (0, jsx_runtime_1.jsx)(elements_1.Div, { styles: { order: isMe ? 3 : 2 } }), (0, jsx_runtime_1.jsxs)(elements_1.Flex, { gap: 2, items: "center", justify: isMe ? 'end' : undefined, styles: { fontSize: constants_1.theme.font.size['6.5'], order: isMe ? 2 : 3 }, children: [(0, jsx_runtime_1.jsx)(elements_1.Text, { bold: true, color: constants_1.Color.DARK_GREY, children: sender.name }), (0, jsx_runtime_1.jsx)(elements_1.Text, { color: constants_1.Color.DARKEST_MEDIUM_GREY, children: date.formatSignificant({ showTime: true }) }), (0, jsx_runtime_1.jsx)(elements_1.Clickable, { className: "group", onClick: () => onToggleFlag(id, flagged), styles: { width: 'auto' }, children: (0, jsx_runtime_1.jsx)(elements_1.Icon, { color: flagged ? constants_1.Color.MEDIUM_DARK_RED : constants_1.Color.DARK_GREY, name: "FlagIcon", design: flagged ? 'solid' : 'outline', size: "sm" }) })] })] }));
};
exports.ChatMessage = ChatMessage;
